import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_add_ticket",
  ref: "addTicketModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_ticket_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Agregar nuevo Ticket", -1)
const _hoisted_6 = {
  id: "kt_modal_add_ticket_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_ticket_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_ticket_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_ticket_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "fv-row mb-7" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Rut", -1)
const _hoisted_12 = { class: "fv-row mb-7" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Nombre", -1)
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "row fv-row mb-7" }
const _hoisted_17 = { class: "col-xl-6" }
const _hoisted_18 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Email", -1)
const _hoisted_20 = {
  class: "fas fa-exclamation-circle ms-1 fs-7",
  "data-bs-toggle": "tooltip"
}
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "col-xl-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Teléfono", -1)
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = {
  class: "fw-bolder fs-3 rotate collapsible mb-7",
  "data-bs-toggle": "collapse",
  href: "#kt_modal_add_ticket_billing_info",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_ticket_view_details"
}
const _hoisted_28 = { class: "ms-2 rotate-180" }
const _hoisted_29 = { class: "svg-icon svg-icon-3" }
const _hoisted_30 = {
  id: "kt_modal_add_ticket_billing_info",
  class: "collapse show"
}
const _hoisted_31 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_32 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tipo Solicitud", -1)
const _hoisted_34 = {
  class: "fas fa-exclamation-circle ms-1 fs-7",
  "data-bs-toggle": "tooltip"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "Solicitud" }, "Solicitud", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "Reclamo" }, "Reclamo", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", { value: "Felicitaciones" }, "Felicitaciones", -1)
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Escriba su requerimiento", -1)
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "modal-footer flex-center" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_modal_add_ticket_cancel",
  class: "btn btn-melon-secundario me-3"
}, " Cancelar ", -1)
const _hoisted_46 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn btn-melon"
}
const _hoisted_47 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_48 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_49 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_Form, {
          class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
          novalidate: "novalidate",
          onSubmit: _ctx.onSubmitTicket,
          id: "kt_add_ticket_form",
          "validation-schema": _ctx.ticket
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg form-control-solid",
                    type: "text",
                    placeholder: "",
                    name: "contactoRut",
                    autocomplete: "off",
                    readonly: "readonly",
                    modelValue: _ctx.profileDetails.contactoRut,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profileDetails.contactoRut) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg form-control-solid",
                    type: "text",
                    placeholder: "",
                    name: "contactoNombre",
                    autocomplete: "off",
                    readonly: "readonly",
                    modelValue: _ctx.profileDetails.contactoNombre,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profileDetails.contactoNombre) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_ErrorMessage, { name: "contactoNombre" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, [
                      _hoisted_19,
                      _withDirectives(_createElementVNode("i", _hoisted_20, null, 512), [
                        [_directive_tooltip, 
                        'Te notificaremos a este correo cuando se responda tu requerimiento'
                      ]
                      ])
                    ]),
                    _createVNode(_component_Field, {
                      class: "form-control form-control-lg form-control-solid",
                      type: "email",
                      placeholder: "",
                      name: "contactoEmail",
                      autocomplete: "off",
                      readonly: "readonly",
                      modelValue: _ctx.profileDetails.contactoEmail,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profileDetails.contactoEmail) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_ErrorMessage, { name: "contactoEmail" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_Field, {
                      class: "form-control form-control-lg form-control-solid",
                      type: "text",
                      placeholder: "",
                      name: "contactoTelefono",
                      autocomplete: "off",
                      readonly: "readonly",
                      modelValue: _ctx.profileDetails.contactoTelefono,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profileDetails.contactoTelefono) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_ErrorMessage, { name: "contactoTelefono" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createTextVNode(" Detalle de la Solicitud "),
                  _createElementVNode("span", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr072.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, [
                      _hoisted_33,
                      _withDirectives(_createElementVNode("i", _hoisted_34, null, 512), [
                        [_directive_tooltip, 
                        'Selecciona el tipo de requerimiento adecuado. Esto nos permitirá agilizar el proceso y la respuesta.'
                      ]
                      ])
                    ]),
                    _createVNode(_component_Field, {
                      name: "tipo",
                      as: "select",
                      class: "form-select form-control-lg form-control-solid"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_35,
                        _hoisted_36,
                        _hoisted_37
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_ErrorMessage, { name: "tipo" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_Field, {
                      as: "textarea",
                      class: "form-control form-control-lg",
                      type: "text",
                      placeholder: "",
                      name: "comentario",
                      autocomplete: "off"
                    }),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_ErrorMessage, { name: "comentario" })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("button", _hoisted_46, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                      _createTextVNode(" Enviar "),
                      _createElementVNode("span", _hoisted_48, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                      _createTextVNode(" Espere... "),
                      _hoisted_50
                    ]))
                  : _createCommentVNode("", true)
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}